module.exports = __webpack_public_path__ + "img/gongshui3.03dc9e64.png";